module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-short-scenario-selection-flow-eec13a58184d5cbdb72ee220a33c4892.png";